let map;
const mapElement = document.getElementById('store_locator_google_map');

const mapStyles = [{
      "featureType": "all",
      "elementType": "labels.text.fill",
      "stylers": [{
         "saturation": 36
      },
      {
         "color": "#000000"
      },
      {
         "lightness": 40
      }
      ]
   },
   {
      "featureType": "all",
      "elementType": "labels.text.stroke",
      "stylers": [{
         "visibility": "on"
      },
      {
         "color": "#000000"
      },
      {
         "lightness": 16
      }
      ]
   },
   {
      "featureType": "all",
      "elementType": "labels.icon",
      "stylers": [{
      "visibility": "off"
      }]
   },
   {
      "featureType": "administrative",
      "elementType": "geometry.fill",
      "stylers": [{
         "color": "#000000"
      },
      {
         "lightness": 20
      }
      ]
   },
   {
      "featureType": "administrative",
      "elementType": "geometry.stroke",
      "stylers": [{
         "color": "#000000"
      },
      {
         "lightness": 17
      },
      {
         "weight": 1.2
      }
      ]
   },
   {
      "featureType": "landscape",
      "elementType": "geometry",
      "stylers": [{
         "color": "#000000"
      },
      {
         "lightness": 20
      }
      ]
   },
   {
      "featureType": "poi",
      "elementType": "geometry",
      "stylers": [{
         "color": "#000000"
      },
      {
         "lightness": 21
      }
      ]
   },
   {
      "featureType": "road.highway",
      "elementType": "geometry.fill",
      "stylers": [{
         "color": "#000000"
      },
      {
         "lightness": 17
      }
      ]
   },
   {
      "featureType": "road.highway",
      "elementType": "geometry.stroke",
      "stylers": [{
         "color": "#000000"
      },
      {
         "lightness": 29
      },
      {
         "weight": 0.2
      }
      ]
   },
   {
      "featureType": "road.arterial",
      "elementType": "geometry",
      "stylers": [{
         "color": "#000000"
      },
      {
         "lightness": 18
      }
      ]
   },
   {
      "featureType": "road.local",
      "elementType": "geometry",
      "stylers": [{
         "color": "#000000"
      },
      {
         "lightness": 16
      }
      ]
   },
   {
      "featureType": "transit",
      "elementType": "geometry",
      "stylers": [{
         "color": "#000000"
      },
      {
         "lightness": 19
      }
      ]
   },
   {
      "featureType": "water",
      "elementType": "geometry",
      "stylers": [{
         "color": "#000000"
      },
      {
         "lightness": 17
      }
      ]
   }
]

async function initiateStoreLocatorGoogleMap() {

  const asideCards = document.querySelectorAll(
    '.store-locator-cards__aside-filtered'
  );

  const storeLongitude = Array.from(
    document.querySelectorAll(
      '.store-locator__card-content-aside .store-locator-card__longitude'
    )
  ).map(item => item.textContent);
  const storeLatitude = Array.from(
    document.querySelectorAll(
      '.store-locator__card-content-aside .store-locator-card__latitude'
    )
  ).map(item => item.textContent);
  const coordinateTitle = Array.from(
    document.querySelectorAll(
      '.store-locator__card-content-aside .store-locator-card__coordinate-title'
    )
  ).map(item => item.textContent);
  const coordinateAddress = Array.from(
    document.querySelectorAll(
      '.store-locator__card-content-aside .store-locator-card__address'
    )
  ).map(item => item.textContent);

  const mapZoomLevelElement =
    document.getElementById('map-zoom-level');
  let mapZoomLevel = 4;
  if (mapZoomLevelElement) {
    mapZoomLevel = Number(mapZoomLevelElement.innerHTML);
  }
  const mapZoomLevelUnit = mapZoomLevel <= 18 ? 3 : 0;

  const locations = [];

  for (let i = 0; i < storeLongitude.length; i++) {
    const coordinateIndex = i;
    const coordinatLatitude = Number(storeLatitude[coordinateIndex]);
    const coordinateT = coordinateTitle[coordinateIndex];
    const coordinateA = coordinateAddress[coordinateIndex];
    const tooltipContent =
      coordinateA && !coordinateT ? coordinateA : coordinateT;

    if (coordinatLatitude && (tooltipContent || 'n/a')) {
      locations.push([
        `<b>${tooltipContent}</b><br/><a href="https://maps.google.com/?q=${coordinatLatitude},${Number(
          storeLongitude[i]
        )}" target="_blank" style="text-decoration: underline;">Location</a>`,
        coordinatLatitude,
        Number(storeLongitude[i])
      ]);
    }
  }

  const minLongitude = Math.min(...storeLongitude);
  const minLatitude = Math.min(...storeLatitude);
  const maxLongitude = Math.max(...storeLongitude);
  const maxLatitude = Math.max(...storeLatitude);

  const centerLatitude = (minLatitude + maxLatitude) / 2;
  const centerLongitude = (minLongitude + maxLongitude) / 2;

  if (
    typeof google === 'undefined' ||
    typeof google.maps === 'undefined'
  ) {
    return;
  }

  map = new google.maps.Map(mapElement, {
    zoom: mapZoomLevel,
    center: { lat: centerLatitude, lng: centerLongitude },
    scrollwheel: false,
    gestureHandling: 'greedy',
    disableDefaultUI: true,
    backgroundColor: '#2B2B2B',
    styles: mapStyles
  });

  const defaultPinIcon = {
   url: mapElement.dataset.mapPinIcon
  };

  const activePinIcon = {
   url: mapElement.dataset.mapActivePinIcon
  };

  const infowindow = new google.maps.InfoWindow({
    maxWidth: 200
  });

  const setMapClickHandler = (item, i) => {
    item.addEventListener('click', function () {
      map.panTo(
        new google.maps.LatLng(locations[i][1], locations[i][2])
      );
      map.setZoom(mapZoomLevel + mapZoomLevelUnit);
    });
  };

  const markers = [];

  for (let i = 0; i < locations.length; i++) {
    setMapClickHandler(asideCards[i], i);
    const marker = new google.maps.Marker({
      position: new google.maps.LatLng(
        locations[i][1],
        locations[i][2]
      ),
      map,
      title: '',
      icon: defaultPinIcon
    });

    markers.push(marker);

    google.maps.event.addListener(
      marker,
      'click',
      (function (marker, count) {
        return function () {
          infowindow.setContent(locations[count][0]);
          infowindow.open(map, marker);
          map.panTo(this.getPosition());

          markers.forEach((m, idx) => {
            if (idx !== count) {
              m.setIcon(defaultPinIcon);
            }
          });

          marker.setIcon(activePinIcon);
        };
      })(marker, i)
    );
  }
}

initiateStoreLocatorGoogleMap();
